import { render, staticRenderFns } from "./pverify-form.vue?vue&type=template&id=0e933aea&scoped=true"
import script from "./pverify-form.vue?vue&type=script&lang=js"
export * from "./pverify-form.vue?vue&type=script&lang=js"
import style0 from "./pverify-form.vue?vue&type=style&index=0&id=0e933aea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e933aea",
  null
  
)

export default component.exports